{ 
  "LanguageSwitch_CurrentLanguage": "Übersetungs-Keys",
  
  "ZZZ_EndOfFile": ""
}
